import { searchBox, pagination, hits, hierarchicalMenu, stats, toggleRefinement, numericMenu, clearRefinements, sortBy, currentRefinements } from 'instantsearch.js/es/widgets';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import instantsearch from 'instantsearch.js';
import '../filters_toggler';
import { parseISO, subDays, addDays, getUnixTime, fromUnixTime } from 'date-fns';

import 'instantsearch.css/themes/reset.css'
import 'instantsearch.css/themes/satellite.css'

const searchClient = instantMeiliSearch(ms_host, ms_key, {
  primaryKey: 'id'
});

const fns = require('date-fns')

let current_date = fns.format(new Date(), "yyyy-MM-dd HH:mm:ss")

const indexName = window.ms_index;

const search = instantsearch({
  searchClient,
  indexName,
  sort: `${indexName}:date_arrival:desc`,
  numberLocale: 'it',
  routing: {
    stateMapping: {
      stateToRoute(uiState) {
        const indexUiState = uiState[indexName];
        return {
          query: indexUiState.query,
          status_new: indexUiState.toggle && indexUiState.toggle.status_new,
          status_pre_owned: indexUiState.toggle && indexUiState.toggle.status_pre_owned,
          status_pre_order: indexUiState.toggle && indexUiState.toggle.status_pre_order,
          price: indexUiState.numericMenu && indexUiState.numericMenu.price,
          date_arrival: indexUiState.numericMenu && indexUiState.numericMenu.date_arrival,
          discounted: indexUiState.toggle && indexUiState.toggle.discounted,
          available: indexUiState.toggle && indexUiState.toggle.available,
          category: indexUiState.hierarchicalMenu && indexUiState.hierarchicalMenu["category.lvl0"] && indexUiState.hierarchicalMenu["category.lvl0"].join('>'),
        }
      },
      routeToState(routeState) {
        return {
          [indexName]: {
            hierarchicalMenu: {
              "category.lvl0": routeState.category && routeState.category.split('>')
            },
            toggle: {
              discounted: routeState.discounted || routeState.filter == 'discounted',
              available: routeState.available || routeState.filter == 'available',
              status_new: routeState.status_new || routeState.filter == 'new',
              status_pre_owned: routeState.status_pre_owned || routeState.filter == 'pre_owned',
              status_pre_order: routeState.status_pre_order || routeState.filter == 'pre_order',
            },
            numericMenu: {
              price: routeState.price,
              date_arrival: routeState.date_arrival
            },
            query: routeState.query,
          },
        };
      },
    },
  },
});

function mapCategory(items) {
  return items.map(item => ({
    ...item,
    label: categories[item.label],
    data: item.data && mapCategory(item.data),
  }))
}

const recapMapping = {
  'available': 'Disponibile',
  'discounted': 'Scontati',
  'status_new': 'Nuovo',
  'status_pre_order': 'Pre-ordine',
  'status_pre_owned': 'Usato',
  'price': 'Prezzo',
  'category.lvl0': 'Categorie'
};

search.addWidgets([

  currentRefinements({
    container: '#current-refinements',

    transformItems(items) {
      return items.map(item => ({
      ...item,
      label: item.label == 'date_arrival' ? 'Data di arrivo' : (recapMapping[item.label] || item.label),
      refinements: item.refinements.map((r) => {
        let label = r.label;
        let value = r.value;
        switch(r.type) {
          case 'hierarchical':
            label = r.label.split('>').map(cid => categories[cid.trim()]).join(' > ')
            break;
          case 'disjunctive':
            label = r.label == 'true' ? 'Si' : 'No';
            break;
          case 'numeric':
            switch(r.attribute) {
              case 'price':
                label = r.label;
                break;
              case 'date_arrival':
                label = fns.format(fromUnixTime(r.value.toString()), "yyyy-MM-dd")
                break;
            }
            break;
        }
        return { ...r, label }
      })
    }));
  }
  }),

  searchBox({
    container: '#searchbox',
  }),

  pagination({
    container: '#pagination-top',
    padding: 1,
  }),

  pagination({
    container: '#pagination-bottom',
    padding: 1,
  }),

  sortBy({
    container: '#sortBy',
    items: [
      { label: 'Rilevanza', value: indexName },
      { label: 'Alfabetico, A-Z', value: `${indexName}:name:asc` },
      { label: 'Alfabetico, Z-A', value: `${indexName}:name:desc` },
      { label: 'Di prezzo - dal più basso', value: `${indexName}:price:asc` },
      { label: 'Di prezzo - dal più alto', value: `${indexName}:price:desc` },
      { label: 'Data di uscita - dal più recente', value: `${indexName}:date_arrival:desc` },
      { label: 'Data di uscita - dal più vecchio', value: `${indexName}:date_arrival:asc` },
    ],
  }),

  clearRefinements({
    templates: {
      resetLabel: 'Reset filtri',
    },
    container: '#clear-refinements',
  }),

  // Tutto quello presente a magazzino escluso i pre-ordini
  toggleRefinement({
    container: '#refinement-list-available',
    attribute: 'available',
    templates: {
      labelText: 'Disponibili',
    },
  }),

  toggleRefinement({
    container: '#refinement-list-discount',
    attribute: 'discounted',
    templates: {
      labelText: 'Scontati',
    },
  }),

  //toggleRefinement({
    //container: '#refinement-list-status-1',
    //attribute: 'status_new',
    //templates: {
      //labelText: 'Nuovo'
    //},
  //}),

  toggleRefinement({
    container: '#refinement-list-status-2',
    attribute: 'status_pre_owned',
    templates: {
      labelText: 'Usato'
    },
  }),

  toggleRefinement({
    container: '#refinement-list-status-3',
    attribute: 'status_pre_order',
    templates: {
      labelText: 'Pre-ordine'
    },
  }),

  //toggleRefinement({
    //container: '#refinement-list-status-4',
    //attribute: 'status_sold_out',
    //templates: {
      //labelText: 'Sold-Out'
    //},
  //}),

  numericMenu({
    container: '#numeric-menu-price',
    attribute: 'price',
    items: [
      { label: 'Tutti' },
      { label: 'Meno di 10€', end: 10.00 },
      { label: 'Tra 10€ e 20€', start: 10.01, end: 20.00 },
      { label: 'Tra 20€ e 50€', start: 20.01, end: 50.00 },
      { label: 'Più di 50€', start: 50.01 },
    ],
  }),

  numericMenu({
    container: '#numeric-menu-date',
    attribute: 'date_arrival',
    items: [
      { label: 'Tutti' },
      { label: 'Ultima settimana', start: getUnixTime(subDays(parseISO(current_date), 7)), end: getUnixTime(parseISO(current_date)) },
      { label: 'Ultimi 30 giorni', start: getUnixTime(subDays(parseISO(current_date), 30)), end: getUnixTime(parseISO(current_date)) },
      { label: 'Prossimi 30 giorni', start: getUnixTime(parseISO(current_date)), end: getUnixTime(addDays(parseISO(current_date), 30)) },
    ],
  }),

  hierarchicalMenu({
    container: '#hierarchical-menu-categories',
    attributes: [
      'category.lvl0',
      'category.lvl1',
      'category.lvl2',
      'category.lvl3',
      'category.lvl4',
    ],
    transformItems(items) { return mapCategory(items) },
    showParentLevel: true,
    limit: 1000,
    templates: {
      item: `
        <a class="ais-HierarchicalMenu-link" href="{{url}}">
          <span class="ais-HierarchicalMenu-label">{{label}}</span>
          </span>
        </a>
      `,
    },
  }),

  stats({
    container: '#stats',
    templates: {
      text: `
        {{#hasNoResults}}0 prodotti{{/hasNoResults}}
        {{#hasOneResult}}1 prodotto{{/hasOneResult}}
        {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} prodotti {{/hasManyResults}}
      `,
    },
  }),

  hits({
    container: "#hits",
    cssClasses: {
      root: 'MyCustomHits',
      list: ['MyCustomHitsList', 'MyCustomHitsList--subclass'],
    },
    transformItems(items) {
      return items.map(item => {

        let available_at = '';
        switch(item.available_at) {
        case 'supplier':
          available_at = "<span class='ProductDetail__availability--yellow'>Disponibile dal fornitore - Arrivo in 2/3 giorni</span>"
          break;
        case 'week':
          available_at = "<span class='ProductDetail__availability--yellow'>Reperibile in 2/5 giorni</span>"
          break;
        case 'request':
          available_at = "<span class='ProductDetail__availability--red'>Non Disponibile – richiedi reperibilit&agrave;</span>"
          break;
        }

        const formatter = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' })

        return ({
          ...item,
          available_at,
          price: formatter.format(item.price),
          price_discounted: formatter.format(item.price_discounted),
        });
      });
    },
    templates: {
      empty: `
        <div class="border-4 border-p1-600 rounded-lg p-4">
          <p class="font-medium text-lg text-p1-600">Nessun Risultato</p>
        </div>`,
      item: `
        {{#status_pre_order}}
          <div class="preorder gradient">
        {{/status_pre_order}}
        {{^status_pre_order}}
          <div>
        {{/status_pre_order}}
          <div class="item-container">
            <div class="CategoryBox__title">
              <a href="/prodotto/{{slug}}">{{name}}</a>
            </div>
            <div class="CategoryBox__content">
              <div class="CategoryBox__image">
                <a href="/prodotto/{{slug}}">
                  <img src="{{image}}">
                </a>
              </div>
              <div class="CategoryBox__details">
                <div class="CategoryBox__attributes">
                  {{#labels}}
                  <div class="CategoryBox__label">{{label}}</div>
                  <div class="CategoryBox__value">{{value}}</div>
                  {{/labels}}
                </div>
                <div class="CategoryBox__price">

                  {{#discounted}}
                    {{price_discounted}}
                    <div class="CategoryBox__priceDiscounted">
                      <strike>{{price}}</strike>
                    </div>
                  {{/discounted}}

                  {{^discounted}}
                    {{price}}
                  {{/discounted}}

                </div>
              </div>
            </div>

            <div class="CategoryBox__availability">
              {{{available_at}}}
            </div>

            {{#status_sold_out}}
              <div class="btn btn--disabled">Esaurito</div>
            {{/status_sold_out}}

            {{^status_sold_out}}
              <div class="CategoryBox__purchase">
                <a class="btn" data-id="{{id}}" data-type="json" data-target="page.cartAddButton" data-action="ajax:success->page#cartAddSuccess" data-remote="true" href="/carrello/aggiungi/{{id}}">
                  {{#status_pre_order}}
                    Prenota
                  {{/status_pre_order}}
                  {{^status_pre_order}}
                    Aggiungi al carrello
                  {{/status_pre_order}}
                </a>
              </div>
            {{/status_sold_out}}

            {{#discounted}}
              <div class="ribbon discounted">
                <span>OFFERTA</span>
              </div>
            {{/discounted}}

            {{#status_pre_owned}}
              <div class="ribbon pre_owned">
                <span>USATO</span>
              </div>
            {{/status_pre_owned}}
          </div>
        </div>
      `,
    },
  })

]);

search.start();
